'use client';

import {
  useAtom,
  useAtomValue,
} from 'jotai';
import { BsFillGridFill } from 'react-icons/bs';
import {
  FaList,
  FaMapLocationDot,
} from 'react-icons/fa6';

import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import { listingsViewAtom } from '@/features/listing/atoms/listings-view-atom';

import styles from './map-view-switch.module.scss';

export default function MapViewSwitch() {
  const [isMapView,
    setIsMapView] = useAtom(isMapViewAtom);

  const listingsView = useAtomValue(listingsViewAtom);

  const handleMapViewChange = () => {
    setIsMapView(!isMapView);
  };

  return (
    <button
      className={styles.mapViewSwitch}
      aria-label="map view switch"
      onClick={handleMapViewChange}
    >
      {isMapView ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {listingsView === 'list' ? (
            // eslint-disable-next-line canonical/prefer-react-lazy
            <FaList className={styles.mapViewSwitch_mapIcon} />
          ) : (
            // eslint-disable-next-line canonical/prefer-react-lazy
            <BsFillGridFill className={styles.mapViewSwitch_mapIcon} />
          ) }
        </>
      ) : (
        // eslint-disable-next-line canonical/prefer-react-lazy
        <FaMapLocationDot className={styles.mapViewSwitch_mapIcon} />
      )}
    </button>
  );
}
